import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const TaskContainer = ({ children }) => (_jsx("div", Object.assign({ className: "panel dskb" }, { children: _jsx("div", Object.assign({ className: "panel-body" }, { children: _jsx("table", Object.assign({ className: "dskb-container" }, { children: _jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { children: children }) }) }) })) })) })));
export default TaskContainer;
